(function ($) {
    var currentCart = document.getCookie('diagram_cart');
    var currectCartEmpty = (currentCart && currentCart.length > 50) ? false : true;
    window.DmCart = {
        init: function () {
            if (!currectCartEmpty) {
                $('.diagram-checkout-link').parent().show();
                $('.diagram-form-title').show();
                var cart = jQuery.parseJSON(currentCart);
                var select = $('ul#diagram-cart-list');
                var itemOrder = 0;
                var creditSum = 0;
                var remainingCredits = 0;
                var userCredits = 0;
                // cart.products.   splice(0,1);
                $.each(cart.products, function (key, product) {
                    creditSum += parseFloat(product['price']);
                    select.append('<li class="item cf ' + product['handle'] + '"><a href="#" onclick="return confirm(\'Are you sure you want to remove this item?\')" data-id="' + itemOrder + '" class="remove remove-diagram-item toggler"><img src="//cdn.shopify.com/s/files/1/0255/1589/t/7/assets/remove.png?8246350234640443595" style="width:15px;" id="removeButton"></a><div class="image"><a href="/products/' + product['handle'] + '?variant=2332586692"><img alt="' + product['title'] + '" src="' + product['image'] + '"></a></div><div class="desc"><a href="/products/' + product['handle'] + '?variant=2332586692" class="name">' + product['title'] + '</a></div><div class="quantotal"><div class="line-total">' + product['price'] + ' Cr</div></div></li>');
                    itemOrder++;
                });
                if(document.SPI_SHOPIFY_USER_ID) {
                $.ajax({
                    url: SPI_API_HOST + "/customers/"+document.SPI_SHOPIFY_USER_ID+"/credits",
                    timeout: 1500,
                    success: function (result) {
                        if (result.length !== 0) {
                            userCredits =  parseInt(result[0]["<CUSTOMER CREDITS>"]);
                        }
                    }
                });
                remainingCredits = userCredits - creditSum;
                if (remainingCredits < 0) {
                    $('#remainingCredit').css('color', '#ff0000');
                }
                $('#remainingCredit span').html(remainingCredits.toFixed(2));
                }
                $('#moneyTotal span').html(creditSum.toFixed(2));
            }
            DmCart.appendEvents();
        },
        appendEvents: function () {
            $(document).on('click', '#update-cart', function (e) {
                if (!currectCartEmpty) {
                    e.preventDefault();
                    window.location = "/pages/checkouts-diagram";
                }
            });

            $(document).on('click', '.buy-credits-button', function (e) {
                e.preventDefault();
                window.location = "/pages/credits";
            });

            $(document).on('click', '.buy-subscription-button', function (e) {
                e.preventDefault();
                window.location = "/pages/manage-your-subscription";
            });

        }

    }
    /* end DmCart class */
    $(function () {
        DmCart.init();
    });
})(jQuery);